<template>
  <div class="message-request-modal" v-if="isOpen">
    <div class="message-request-wrapper">
      <div
        data-w-id="150735b1-3e6f-fc67-a109-a12e2e2f0ba7"
        class="link-block-5 w-inline-block"
        @click="cancel"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
      <div class="success-gif-container">
        <img
          src="@/assets/timeslot-images/animation_500_l3vkfkxp.gif"
          loading="lazy"
          width="170"
          alt=""
        />
      </div>

      <div class="text-block text-block-success">Successful</div>
      <div class="text-block-3 text-block-success">{{ message }}</div>
      <div class="button-15 w-button" @click="buttonAction">Continue</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessMessageModal",
  props: {
    message: String,
    buttonAction: Function,
    cancel: Function,
    isOpen: Boolean
  }
};
</script>

<style scoped>
.text-block-success {
  text-align: center;
}
.success-gif-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
